export default __webpack_public_path__ + "static/media/no_data_found.4ae4b2b5.lottie";